import { TranslateService } from '@ngx-translate/core';

/**
 * buildParamsBasedEntry
 * @param params
 * @param translate
 * Switch through potential PredicateTypes and kick out to helpers to
 *    build the human-readable log entry
 */
export const buildParamsBasedEntry = (params, translate: TranslateService) => {
  switch (params.PredicateType) {
    case 'Academy':
      return buildAcademyEntry(params, translate);
    case 'Skill':
      return buildSkillEntry(params, translate);
    default:
      return '';
  }
};

/**
 * Academy helper functions
 */
const buildAcademyEntry = (acadParameter, translate: TranslateService) =>
  translate.instant(`Automation_AcademyIs`, {
    academy: getFieldName(acadParameter),
    status: buildSimpleOrList(
      JSON.parse(acadParameter.UserAcademyStatus),
      translate
    ),
  });

/**
 * Skill helper functions
 */

const buildSkillEntry = (skillParameter, translate: TranslateService) => {
  if (skillParameter.TimeFrame > 0) {
    return skillParameter.TimeFrame == 1
      ? translate.instant(
          'Automation_SkillConditionWithinTheLastDay_Formatted',
          {
            condition: translate.instant(
              `Automation_SkillOperator_${skillParameter.ComparisonOperator}`
            ),
          }
        )
      : translate.instant(
          'Automation_SkillConditionWithinTheLastDays_Formatted',
          {
            condition: translate.instant(
              `Automation_SkillOperator_${skillParameter.ComparisonOperator}`
            ),
            number: skillParameter.TimeFrame,
          }
        );
  }
  if (skillParameter.SkillName?.length > 0) {
    return translate.instant('Automation_SkillConditionFor_Format', {
      condition: translate.instant(
        `Automation_SkillOperator_${skillParameter.ComparisonOperator}`
      ),
      skill: buildSimpleOrList(skillParameter.SkillName, translate),
    });
  }
  if (skillParameter.ComparisonOperator.length > 0) {
    return translate.instant(
      `Automation_SkillOperator_${skillParameter.ComparisonOperator}`
    );
  }
  return ' ';
};

/**
 * Shared helper functions
 */

/**
 * buildSimpleOrList
 * @param value
 * @param translate
 * @returns a simple comma-separated list of values, with translated 'or' before the last item
 */
export const buildSimpleOrList = (value, translate: TranslateService) => {
  const or = translate.instant('Core_Or');
  if (value.length < 2) {
    return value;
  } else if (value.length > 21) {
    // Why 21 above and 20 below?  Because +1 more looks silly.
    return (
      value.slice(0, 20).join(', ') +
      ', ' +
      translate.instant('Automations_Plus_X_More_Format', {
        count: value.length - 20,
      })
    );
  } else {
    const commaList = value.slice(0, -1).join(', ');
    const lastItem = value.slice(-1);

    return `${commaList} ${or} ${lastItem}`;
  }
};

/**
 * getFieldName
 * @param params
 * Newer predicate types need to extract the equivalent to fieldName
 *   from the parameters object
 * This may be different depending on the type, but we fall back to the
 *  PredicateType if we can't find a specific field
 */
export const getFieldName = (params) => {
  if (params.PredicateType === 'Academy') {
    return params.AcademyName;
  }
  return params.PredicateType; // fallback
};
